/* script */
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import Badge from '../../../../frontend/views/components/Badge.vue'
import NotificationCard from './NotificationCard.vue'

const __vue_script__ = {
  name: 'NotificationBell',
  components: {
    Badge,
    NotificationCard
  },
  computed: {
    ...mapGetters([
      'currentUnreadNotificationCount'
    ])
  }
}

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "router-link",
        {
          staticClass: "button is-icon-small c-btn hide-tablet",
          attrs: { to: { query: { modal: "NotificationModal" } } },
        },
        [
          _c("i", {
            staticClass: "icon-bell",
            class: { "is-active": _vm.currentUnreadNotificationCount },
          }),
          _vm.currentUnreadNotificationCount
            ? _c("badge", { attrs: { "data-test": "alertNotification" } }, [
                _vm._v(_vm._s(_vm.currentUnreadNotificationCount)),
              ])
            : _vm._e(),
        ],
        1
      ),
      _c("notification-card", [
        _c(
          "button",
          { staticClass: "is-icon-small c-btn hide-phone" },
          [
            _c("i", {
              staticClass: "icon-bell",
              class: { "is-active": _vm.currentUnreadNotificationCount },
            }),
            _vm.currentUnreadNotificationCount
              ? _c("badge", { attrs: { "data-test": "alertNotification" } }, [
                  _vm._v(_vm._s(_vm.currentUnreadNotificationCount)),
                ])
              : _vm._e(),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-0762b3b9_0", { source: ".c-badge[data-v-0762b3b9] {\n  top: -0.25rem;\n  right: -0.25rem;\n}\n.icon-bell[data-v-0762b3b9] {\n  font-size: 0.9rem;\n  transform-origin: center 2px;\n  margin-top: 2px;\n}\n.icon-bell.is-active[data-v-0762b3b9] {\n  font-weight: 900;\n}\n.c-btn:hover .icon-bell[data-v-0762b3b9],\n.c-btn:focus .icon-bell[data-v-0762b3b9] {\n  animation: bell-data-v-0762b3b9 750ms forwards;\n}\n@keyframes bell-data-v-0762b3b9 {\n10% {\n    transform: rotate(15deg);\n}\n20% {\n    transform: rotate(-15deg);\n}\n35% {\n    transform: rotate(15deg);\n}\n60% {\n    transform: rotate(-10deg);\n}\n80% {\n    transform: rotate(5deg);\n}\n}\n\n/*# sourceMappingURL=NotificationBell.vue.map */", map: {"version":3,"sources":["frontend/views/containers/notifications/NotificationBell.vue","NotificationBell.vue"],"names":[],"mappings":"AAiCA;EACA,aAAA;EACA,eAAA;AChCA;ADmCA;EACA,iBAAA;EACA,4BAAA;EACA,eAAA;AChCA;ADkCA;EACA,gBAAA;AChCA;ADsCA;;EACA,8CAAA;AClCA;ADsCA;AACA;IAAA,wBAAA;AClCE;ADmCF;IAAA,yBAAA;AChCE;ADiCF;IAAA,wBAAA;AC9BE;AD+BF;IAAA,yBAAA;AC5BE;AD6BF;IAAA,uBAAA;AC1BE;AACF;;AAEA,+CAA+C","file":"NotificationBell.vue","sourcesContent":["<template lang='pug'>\ndiv\n  router-link.button.is-icon-small.c-btn.hide-tablet(:to='{ query: { modal: \"NotificationModal\" }}')\n    i.icon-bell(:class='{ \"is-active\": currentUnreadNotificationCount }')\n    badge(v-if='currentUnreadNotificationCount' data-test='alertNotification') {{ currentUnreadNotificationCount }}\n  notification-card\n    button.is-icon-small.c-btn.hide-phone\n      i.icon-bell(:class='{ \"is-active\": currentUnreadNotificationCount }')\n      badge(v-if='currentUnreadNotificationCount' data-test='alertNotification') {{ currentUnreadNotificationCount }}\n</template>\n\n<script>\nimport { mapGetters } from 'vuex'\nimport Badge from '../../../../frontend/views/components/Badge.vue'\nimport NotificationCard from './NotificationCard.vue'\n\nexport default {\n  name: 'NotificationBell',\n  components: {\n    Badge,\n    NotificationCard\n  },\n  computed: {\n    ...mapGetters([\n      'currentUnreadNotificationCount'\n    ])\n  }\n}\n</script>\n\n<style lang=\"scss\" scoped>\n@import \"../../../../frontend/assets/style/_variables.scss\";\n\n.c-badge {\n  top: -0.25rem;\n  right: -0.25rem;\n}\n\n.icon-bell {\n  font-size: 0.9rem;\n  transform-origin: center 2px;\n  margin-top: 2px;\n\n  &.is-active {\n    font-weight: 900;\n  }\n}\n\n.c-btn:hover,\n.c-btn:focus {\n  .icon-bell {\n    animation: bell 750ms forwards;\n  }\n}\n\n@keyframes bell {\n  10% { transform: rotate(15deg); }\n  20% { transform: rotate(-15deg); }\n  35% { transform: rotate(15deg); }\n  60% { transform: rotate(-10deg); }\n  80% { transform: rotate(5deg); }\n}\n</style>\n",".c-badge {\n  top: -0.25rem;\n  right: -0.25rem;\n}\n\n.icon-bell {\n  font-size: 0.9rem;\n  transform-origin: center 2px;\n  margin-top: 2px;\n}\n.icon-bell.is-active {\n  font-weight: 900;\n}\n\n.c-btn:hover .icon-bell,\n.c-btn:focus .icon-bell {\n  animation: bell 750ms forwards;\n}\n\n@keyframes bell {\n  10% {\n    transform: rotate(15deg);\n  }\n  20% {\n    transform: rotate(-15deg);\n  }\n  35% {\n    transform: rotate(15deg);\n  }\n  60% {\n    transform: rotate(-10deg);\n  }\n  80% {\n    transform: rotate(5deg);\n  }\n}\n\n/*# sourceMappingURL=NotificationBell.vue.map */"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-0762b3b9"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "<template lang='pug'>\ndiv\n  router-link.button.is-icon-small.c-btn.hide-tablet(:to='{ query: { modal: \"NotificationModal\" }}')\n    i.icon-bell(:class='{ \"is-active\": currentUnreadNotificationCount }')\n    badge(v-if='currentUnreadNotificationCount' data-test='alertNotification') {{ currentUnreadNotificationCount }}\n  notification-card\n    button.is-icon-small.c-btn.hide-phone\n      i.icon-bell(:class='{ \"is-active\": currentUnreadNotificationCount }')\n      badge(v-if='currentUnreadNotificationCount' data-test='alertNotification') {{ currentUnreadNotificationCount }}\n</template>\n\n<script>\nimport { mapGetters } from 'vuex'\nimport Badge from '../../../../frontend/views/components/Badge.vue'\nimport NotificationCard from './NotificationCard.vue'\n\nexport default {\n  name: 'NotificationBell',\n  components: {\n    Badge,\n    NotificationCard\n  },\n  computed: {\n    ...mapGetters([\n      'currentUnreadNotificationCount'\n    ])\n  }\n}\n</script>\n\n<style lang=\"scss\" scoped>\n@import \"../../../../frontend/assets/style/_variables.scss\";\n\n.c-badge {\n  top: -0.25rem;\n  right: -0.25rem;\n}\n\n.icon-bell {\n  font-size: 0.9rem;\n  transform-origin: center 2px;\n  margin-top: 2px;\n\n  &.is-active {\n    font-weight: 900;\n  }\n}\n\n.c-btn:hover,\n.c-btn:focus {\n  .icon-bell {\n    animation: bell 750ms forwards;\n  }\n}\n\n@keyframes bell {\n  10% { transform: rotate(15deg); }\n  20% { transform: rotate(-15deg); }\n  35% { transform: rotate(15deg); }\n  60% { transform: rotate(-10deg); }\n  80% { transform: rotate(5deg); }\n}\n</style>\n"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__